import { AnyAction, Dispatch } from 'redux';
import { AppState } from '../../../store/store';
import { AppState as Auth0State } from '@auth0/auth0-react';
import { RedirectLoginOptions } from '@auth0/auth0-react';
import { ThunkResult } from './ThunkResult';
import AnalyticsEventUtil from '../../../infra/analytics/analytics-event-util';

export const navigateToLoginAction = (loginWithRedirect: (options: RedirectLoginOptions<Auth0State>) => Promise<void>): ThunkResult<void> => {
  return async (dispatch: Dispatch<AnyAction>, getState: () => AppState) => {
    const returnUrl = window.location.pathname;
    AnalyticsEventUtil.getInstance().navigateToLogin(returnUrl);
    loginWithRedirect({ appState: { returnTo: returnUrl } });
  };
};
